

$(document).ready(function(){

  //reformat page
  //remove meta
  $( "meta" ).remove();

  //unwrap img with p wrapper
	$('img')
    .filter(function() {
  		var p=$(this).parent('p');
  		if(p.length==0)return;
        return $.trim( $(this).parent('p').text()) === '' ;
    })
    .unwrap()
    
    //remove empty p
   	$('p')
    .filter(function() {
        return $.trim( $(this).text()) === '' ;
    })
    .remove()


  //check if p follow img in product-single
      wrapElements('img', 'p');
      wrapElements('.image', 'p');
      wrapElements('img', 'ul');
      wrapElements('span', 'p');
      wrapElements('img', 'table');
      wrapElements('img', 'h2');
      wrapElements('.image', '.text');
      wrapElements('img', '.text');
      wrapElements('span', '.text');
      wrapElements('iframe', '.text');
      wrapElements('iframe', 'p');


      $("iframe").ready( function(){
          wrapElements('.video-wrapper', 'p'); 
          wrapElements('.video-wrapper', '.text');

          $('iframe[src*="vimeo"]').parent().fitVids();
          $('iframe[src*="youtube"]').parent().fitVids();

      });


      spaceSpanElements();
  

	  //hide process if no instagram  
 	 $('.product-instagram-container').change(function(changes, observer) {
			    //console.log('changed');

                //if ($(".instashow-gallery-container").height() <= 0){ 
                  if (!$.trim( $('.instashow-gallery-container').html() ).length ){ 
                    $(".instashow-gallery-wrapper").slideUp();
                    $(".process").slideUp();
                  }  
                else{

                    $(".instashow-gallery-wrapper").slideDown();
                    $(".process").slideDown();

                      setTimeout(function(){
                        //console.log("setcolor");
                      
                        
                        
                        //set background dot color'
                      var clr=$(".dot").css("background-color");
                      if( $(window).width()>768){
                          $(".instashow-gallery-view-active").css({
                            background :"radial-gradient("+clr+" 5%, white 6%)",
                            backgroundSize :"20% 50%",
                          });

                      }else{

                        $(".instashow-gallery-view-active").css({
                           background :"radial-gradient("+clr+" 5%, white 6%)",
                           backgroundSize :"50% 25%",
                        });
                      }

                    },1500);

                }

      });
  
 
});



// a minimal jQuery library for reacting to innerHTML changes
(function($) {
  $.fn.change = function(cb, e) {
    e = e || { subtree:true, childList:true, characterData:true };
    $(this).each(function() {
      function callback(changes) { cb.call(node, changes, this); }
      var node = this;
      (new MutationObserver(callback)).observe(node, e);
    });
  };
})(jQuery);

 
// Pass in the target node, as well as the observer options
//observer.observe(target, config);
 
// Later, you can stop observing
//observer.disconnect();








function spaceSpanElements(){
  //find span elements and space inside elements evenly

  //var span=$( ".product-description" ).find( '.span' ).children();
  $( ".product-description" ).find( 'span, .span' ).each(function(){
      var children=$(this).children();
      var divide;

      if(children.length==2)divide='one-half';
      else if(children.length==3)divide='one-third';
      else if(children.length==4)divide='one-quarter';
      else if(children.length==5)divide='one-fifth';
      else if(children.length==6)divide='one-sixth';

      $(children).each(function(){
          $(this).wrap( "<div class='grid__item "+divide+"'></div>" );

      });
    
  });

}



function wrapElements(a, b){
    var els=$( ".product-description" ).find( a+"+"+b ).prev();
     els.each(function(){
      var b=$(this).next();//.css( "background-color", "red" );
      if ($(b).text().trim().length) {
        $(this).wrap( "<div class='type-image-text'></div>" );
        $(this).wrap( "<div></div>" );

        var wrappedA=$(this).parent();

        //$(this).wrap( "<div class='image-text-block'></div>" );
        $(wrappedA).after(b);
        $(b).wrap( "<div></div>" );
        $(b).wrap( "<div></div>" );

      }
    });

}
 
  